import { render, staticRenderFns } from "./user-deactivation-settings.vue?vue&type=template&id=46b31917&scoped=true&"
import script from "./user-deactivation-settings.vue?vue&type=script&lang=js&"
export * from "./user-deactivation-settings.vue?vue&type=script&lang=js&"
import style0 from "./user-deactivation-settings.vue?vue&type=style&index=0&id=46b31917&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b31917",
  null
  
)

component.options.__file = "user-deactivation-settings.vue"
export default component.exports